import React, { type FC } from 'react';

import { useLivePageMode } from '@confluence/live-pages-utils/entry-points/useLivePagesStore';
import {
	ExperienceFailure,
	TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE,
} from '@confluence/experience-tracker';

import type { ContentMode } from '../presenceTypes';

import { usePresenceProvider } from './usePresenceProvider';
import { ContentHeaderPresenceContainer } from './ContentHeaderPresenceContainer';

export type PresenceProps = {
	contentId: string;
	contentMode: ContentMode;
	contentType: string;
	analyticSource?: string;
};

export const Presence: FC<PresenceProps> = ({
	contentId,
	contentMode,
	contentType,
	analyticSource,
}) => {
	const [{ isEditMode }] = useLivePageMode();
	const activity = contentMode === 'edit' || isEditMode ? 'editor' : 'viewer';

	const { sessionId, fetchMore, networkError } = usePresenceProvider(
		contentId,
		contentType,
		contentMode,
		activity,
	);

	if (networkError) {
		return (
			<ExperienceFailure name={TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE} error={networkError} />
		);
	}

	return (
		<ContentHeaderPresenceContainer
			contentId={contentId}
			contentMode={contentMode}
			contentType={contentType}
			analyticSource={analyticSource}
			currentUserPresenceSessionId={sessionId}
			onLoadMoreClick={fetchMore}
		/>
	);
};
